'use strict';

/**
 * Created by @圣司 on 16/3/24.
 * @fileoverview 统一侵入组件
 * @author 圣司<shudi.zsd@alibaba-inc.com>
 */

var PIPE_JOBS_KEY = '__PIPE_JOBS';
var PIPE_EXPIRT_TIME_KEY = '__PIPE_EXPIRT_TIME';

var util = require('./util/util');
var localstorage = require('./util/localstorage');
var LocDataManager = require('./util/loc-data-manager');
var check = require('./check');

var host = location.host;
var search = location.search;
var pipeVersion = '@@version';

var disabledPipe = false; //是否禁用 Pipe

if (/[\?&]disabled_pipe([=&]|$)/i.test(location.search) || util.getMeta('disabled_pipe') == 'true') {
    disabledPipe = true;
}

// 初始化缓存控制器
var ldm = new LocDataManager({
    key: PIPE_JOBS_KEY,
    expirtTime: parseInt(localstorage.get(PIPE_EXPIRT_TIME_KEY)) || 900,
    version: pipeVersion
});

var dev = false; // 是否开发环境
var daily = false; //是否日常环境

// 开发环境
if (/[\?&]pipe_dev([=&]|$)/i.test(location.search)) {
    dev = true;
}

// 日常环境
if (/^(dev|demo)\./i.test(host) || /waptest.(taobao|alitrip).com/i.test(host) || /[\?&]pipe_daily([&=]|$)/i.test(location.search)) {
    daily = true;
}

var disabledPipeCache = false; // 是否禁用 LocalStorage

// 开发环境 & 日常环境 不走本地缓存
if (dev || daily) {
    disabledPipeCache = true;
}

//URL 传参禁用缓存
if (/[\?&]disabled_pipe_cache([=&]|$)/i.test(search) || util.getMeta('disabled_pipe_cache') == 'true') {
    disabledPipeCache = true;
}

var Pipe = {
    getJobs: function getJobs() {

        // 防 XSS, 关闭缓存
        disabledPipeCache = true;

        // 禁用缓存时, 将缓存清空; 否则优先从缓存读取任务
        if (disabledPipeCache) {
            ldm.remove();
        } else {
            var locData = ldm.get();

            if (locData && locData.data) {
                try {
                    window.eval && window.eval('window.__PipeTempFunction = ' + locData.data);
                    this.run(window.__PipeTempFunction);
                    return;
                } catch (e) {}
            }
        }

        // 开发或日常环境请求日常任务列表
        var url = dev ? 'http://dev.m.taobao.com/pipe-job.js' : daily ? '//g-assets.daily.taobao.net/trip/pipe-job/pipe-job.js' : '//g.alicdn.com/trip/pipe-job/pipe-job.js';

        if (window.KISSY && KISSY.use) {
            KISSY.use('', function (S) {
                S.getScript(url + '?t=' + new Date().getTime(), {
                    charset: 'utf-8'
                });
            });
        } else if (window.Zepto) {
            $.ajaxJSONP({
                url: url + '?t=' + new Date().getTime() + '&callback=?'
            });
        }
    },

    run: function run(taskFun) {
        var conf = taskFun();

        if (util.isNumber(conf.config && conf.config.expirtTime)) {
            localstorage.set(PIPE_EXPIRT_TIME_KEY, conf.config.expirtTime);
        }

        //使用缓存的情况下, 任务存入缓存
        !disabledPipeCache && ldm.set({
            data: taskFun.toString(),
            version: pipeVersion
        });

        if (!checkGlobalConfig(conf)) {
            console.log('PIPE: 全局配置校验失败!');
            return;
        }

        var taskList = conf.taskList;

        if (!util.isArray(taskList) || !taskList.length) {
            return;
        }

        taskList.forEach(function (task) {
            dev && console.log('\nPIPE: 开始校验任务 [' + task.name + '] ...');
            if (!util.isObject(task) || !checkRule(task.rule) || !checkPeriod(task.period)) {
                dev && console.log('PIPE: 任务 [' + task.name + '] 校验失败!\n');
                return;
            }

            dev && console.log('PIPE: 任务 [' + task.name + '] 校验成功!\n');

            checkRunTime(task);
        });
    }
};

function runJsJob(job) {
    if (!job.script || !util.isString(job.script)) {
        return;
    }

    try {
        window.eval && window.eval(job.script);
    } catch (e) {}
}

function runCssJob(job) {
    if (!job.style || !util.isString(job.style)) {
        return;
    }

    try {
        var style = document.createElement("style");
        (document.getElementsByTagName("head")[0] || document.body).appendChild(style);
        style.appendChild(document.createTextNode(job.style));
    } catch (e) {}
}

function runHtmlJob(job) {
    if (!job.content || !util.isString(job.content)) {
        return;
    }

    var method = ['prepend', 'append', 'before', 'after', 'html'].indexOf(job.method) > -1 ? job.method : 'prepend';

    if (window.KISSY && KISSY.use) {
        KISSY.use('node', function (S, Node) {
            var $ = job.all ? S.all : S.one;

            try {
                $(job.target)[method](job.content);
            } catch (e) {}
        });
    } else if (window.Zepto) {
        try {
            var node = $(job.target);
            if (!job.all) {
                node = node.first();
            }

            node[method](job.content);
        } catch (e) {}
    }
}

// 校验全局配置, 主要是 Pipe 版本号等
function checkGlobalConfig(conf) {

    if (!util.isObject(conf)) {
        return false;
    }

    var _version = conf.config && conf.config.version && conf.config.version.split('.') || [];
    var _pipeVersion = pipeVersion && pipeVersion.split('.') || [];

    //开发环境兼容
    if (_pipeVersion[0].indexOf('version') > -1) {
        return true;
    }

    // 设置为 * 的版本号位默认校验通过
    for (var i = 0; i <= 2; ++i) {
        if (_version[i] !== '*' && _version[i] !== _pipeVersion[i]) {
            return false;
        }
    }

    return true;
}

// 验证页面匹配规则
function checkRule(rule) {

    //多条配置情况
    if (util.isArray(rule)) {
        //任一条规则匹配上则匹配成功
        return rule.some(function (item) {
            return checkRule(item);
        });
    }

    var url, // url 规则
    spm, // spm 规则
    projVersion, // 项目版本号匹配
    baseVersion, // base 版本号匹配
    app, // 容器匹配
    os; // 系统匹配

    if (util.isString(rule)) {
        spm = rule;
    } else if (util.isObject(rule)) {
        url = rule.url;
        spm = rule.spm;
        projVersion = rule.projVersion;
        baseVersion = rule.baseVersion;
        app = rule.app;
        os = rule.os;
    } else {
        console.log('PIPE: 匹配规则 rule 参数配置错误!');
        return false;
    }

    // url 与 spm 至少提供一个规则
    if (!url && !spm) {
        console.log('PIPE: 匹配规则 rule 参数配置错误, url/spm 规则请至少提供其中之一!');
        return false;
    }

    // url 规则匹配
    if (url && !check.checkUrl(url)) {
        dev && console.log('PIPE: URL 校验失败!');
        return false;
    }

    // spm 规则匹配
    if (spm && !check.checkSpm(spm)) {
        dev && console.log('PIPE: spm 校验失败!');
        return false;
    }

    // base 版本号匹配
    if (baseVersion && !check.checkBaseVersion(baseVersion)) {
        dev && console.log('PIPE: base 版本校验失败!');
        return false;
    }

    // 项目版本号匹配
    if (projVersion && !check.checkProjVersion(projVersion)) {
        dev && console.log('PIPE: 项目版本校验失败!');
        return false;
    }

    // 容器匹配
    if (app && !check.checkApp(app)) {
        dev && console.log('PIPE: 容器校验失败!');
        return false;
    }

    // 平台匹配
    if (os && !check.checkOS(os)) {
        dev && console.log('PIPE: 系统校验失败!');
        return false;
    }

    return true;
}

// 验证注入时间规则
// 目前采用本地时间, TODO 后续考虑使用服务器时间
function checkPeriod(period) {
    if (!period || !period.start && !period.end) {
        return true;
    }

    var now = new Date();
    var start = util.formatDate(period.start);
    var end = util.formatDate(period.end);

    var res = !(start && now < start || end && now > end);

    !res && dev && console.log('PIPE: 执行时间校验失败!');

    return res;
}

// 判断执行时间并在相应时间调用执行方法
function checkRunTime(task) {

    var trigger, delay;

    if (util.isString(task.runTime)) {
        trigger = task.runTime || 'ready';
        delay = null;
    } else if (util.isObject(task.runTime)) {
        trigger = task.runTime.trigger || 'ready';
        delay = task.runTime.delay || null;
    } else {
        trigger = 'ready';
        delay = null;
    }

    switch (trigger) {
        case 'now':
            excute(task.jobs, delay);
            break;
        case 'ready':
            if (window.KISSY && KISSY.ready) {
                // 如果页面上有 KISSY，使用 KISSY 的方法
                KISSY.ready(function () {
                    excute(task.jobs, delay);
                });
            } else if (window.Zepto) {
                // 如果页面上存在 jQuery，使用 jQuery 的方法
                $(function () {
                    excute(task.jobs, delay);
                });
            } else {
                if (document.readyState === "complete") {
                    excute(task.jobs, delay);
                } else {
                    window.addEventListener('load', function () {
                        excute(task.jobs, delay);
                    }, false);
                }
            }
            break;
        default:
            document.addEventListener(trigger, function () {
                excute(task.jobs, delay);
            }, false);
            break;
    }
}

// 判断延迟时间, 任务类型后, 分发任务至执行器
function excute(jobs, delay) {
    if (!util.isArray(jobs) || !jobs.length) {
        return;
    }

    var _run = function _run() {
        jobs.forEach(function (job) {
            if (job.script) {
                runJsJob(job);
            } else if (job.style) {
                runCssJob(job);
            } else if (job.content) {
                runHtmlJob(job);
            }
        });
    };

    if (util.isNumber(delay)) {
        setTimeout(function () {
            _run();
        }, delay);
    } else {
        _run();
    }
}

module.exports = Pipe;

window.Pipe = Pipe;

if (window.KISSY && KISSY.add) {
    KISSY.add('pipe/index', function () {
        return Pipe;
    });
}

if (!disabledPipe) {
    // 开始执行获取任务方法
    Pipe.getJobs();
}


/*****************
 ** WEBPACK FOOTER
 ** ./components/pipe/index.js
 ** module id = 9
 ** module chunks = 0
 **/